import { useMutation } from "react-query";
import { getUploadFile } from "../services";
import usePrint from "../../../hooks/usePrint";
import usePopup from "../../../hooks/usePopup";

const useViewFile = () => {
  const { printPdf } = usePrint();
  const { showSnackbar } = usePopup();
  return useMutation(getUploadFile, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        printPdf(result.response, "new-tab");
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
};

export default useViewFile